@if (card.data) {
    @if (!card.context.use_new_ui) {
        <app-carousel [config]="splideConfig">
            @for (item of card.data; track item) {
                <app-slide (click)="openLink(item)">
                    <article [style.backgroundImage]="handleBackground(item.image_url)" [style.aspectRatio]="aspect_ratio">
                        @if (item.title !== null && item.title !== '') {
                            <footer class="article-title">
                                {{ item.title }}
                            </footer>
                        }
                        @if (!item?.image_url?.includes?.('bleachr-webclient:video_button') && item?.type?.toLowerCase?.() === 'video') {
                            <img class="video-button-img" src="/assets/play_button.png" />
                        }
                    </article>
                </app-slide>
            }
        </app-carousel>
    } @else {
        <app-new-ui-layout [card]="card" [is_feed_component]="false" [timeline_id]="timeline_id"></app-new-ui-layout>
    }
}
